import { render, staticRenderFns } from "./TwoStepCaptcha.vue?vue&type=template&id=a40ad35a&scoped=true"
import script from "./TwoStepCaptcha.vue?vue&type=script&lang=js"
export * from "./TwoStepCaptcha.vue?vue&type=script&lang=js"
import style0 from "./TwoStepCaptcha.vue?vue&type=style&index=0&id=a40ad35a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40ad35a",
  null
  
)

export default component.exports